import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "react-alice-carousel/lib/alice-carousel.css";
import CryptoContext from "./CryptoContext";
import { Buffer } from "buffer";
import "stream-browserify";
import "stream-http";
import "https-browserify";
window.Buffer = Buffer;

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CryptoContext>
      <App />
    </CryptoContext>
  </React.StrictMode>
);
